import bullettrainthumb from "../images/bullettrainthumb.png";
import BulletTrainscene from "../images/BulletTrainscene.webp";
import bullettrainlogo from "../images/bullettrainlogo.png";
import spidey from "../images/spidey.png";
import jumanji from "../images/jumanji.png";
import jumanjiscene from "../images/jumanjiscene.png";
import jumanjilogo from "../images/jumanjilogo.png";
import wolf from "../images/wolf.png";
import wolflogo from "../images/wolflogo.png";
import wolfscene from "../images/wolfscene.png";
import mrs from "../images/mrs.png";
import hob from "../images/hob.png";
import spideyLogo from "../images/spideyLogo.png";
import spideyScene from "../images/spideyScene.png";
import moralis from "../images/moralis.png";
import moralisLogo from "../images/moralisLogo.png";
import moralisScene from "../images/moralisScene.png";
import bayw from "../images/bayw.png";
import shrek from "../images/shrek.png";
import lucy from "../images/lucy.png";
import topgu from "../images/topgu.png";
import imit from "../images/imit.png";
import reven from "../images/reven.png";
import tomb from "../images/tomb.png";
import amaz from "../images/amaz.png";
import bigs from "../images/bigs.png";
import secona from "../images/secona.png";
import ted from "../images/ted.png";
import amerp from "../images/amerp.png";
import rushhour1thumb from "../images/rushhour1thumb.png";
import rushour1scenes from "../images/rushour1scenes.png";
import RushHour1Logo from "../images/RushHour1Logo.png";

export const movies = [
  {
    Movie: "",
    Thumbnail: bullettrainthumb,
    Scene: BulletTrainscene,
    Logo: bullettrainlogo,
    Name: "Bullet Train",
    Description:
      "Unlucky assassin Ladybug is determined to do his job peacefully after one too many gigs gone off the rails. Fate, however, may have other plans, as Ladybug's latest mission puts him on a collision course with lethal adversaries from around the globe—all with connected, yet conflicting, objectives—on the world's fastest train.",
    Genre: "Action, Crime, Comedy",
    Actors: "Aaron Taylor-Johnson, Brian Tyree Henry, Bad Bunny, Zazie Beetz, Michael Shannon",
    Year: "2022-07-03",
    Duration: "127 min",
  },
  {
    Movie: "https://ipfs.moralis.io:2053/ipfs/QmNtxfy9Mk8qLsdGnraHGk5XDim8ayR93krM24ETJEd2bG/media/0",
    Thumbnail: spidey,
    Scene: spideyScene,
    Logo: spideyLogo,
    Name: "Spider-Man: No Way Home",
    Description: "Spider-Man seeks the help of Doctor Strange to forget his exposed secret identity as Peter Parker. However, Strange's spell goes horribly wrong, leading to unwanted guests entering their universe.",
    Genre: "Action, Science Fiction, Adventure, Fantasy",
    Actors: "Tom Holland, Zendeya, Benedict Cumberbatch, Tobey Maguire, Andrew Garfield",
    Year: "2021-12-15",
    Duration: "148 min",
  },
  {
    Movie: "https://ipfs.io/ipfs/QmRbCY1DkiTBfvLyGPcaU5Q7LLbhfP9rtBtHo527KoWbmU?filename=Morbius2022.mp4",
    Thumbnail: jumanji,
    Scene: jumanjiscene,
    Logo: jumanjilogo,
    Name: "Jumanji",
    Description: "Determined to cure the disease that has plagued him his entire life, Morbius conducts a drastic experiment, which bears unforeseen consequences.",
    Genre: "Action, Adventure, Comedy, Fantasy",
    Actors: "Dwayne Johnson, Jack Black, Kevin Hart, Karen Gillan, Danny DeVito",
    Year: "2019-12-04",
    Duration: "123 min",
  },
  {
    Movie: "https://ipfs.moralis.io:2053/ipfs/QmWWnyCZwh8RVnamjeLhGmpYM2C3oDr3FzF7zgv5ur24z5/media/0",
    Thumbnail: moralis,
    Scene: moralisScene,
    Logo: moralisLogo,
    Name: "Thor: Love and Thunder",
    Description: "Thor embarks on a journey unlike anything he's ever faced -- a quest for inner peace. However, his retirement gets interrupted by Gorr the God Butcher, a galactic killer who seeks the extinction of the gods.The fourth installment of the Marvel Studios' Thor movie series.",
    Genre: "Action, Comedy, Science Fiction, Adventure, Fantasy",
    Actors: "Chris Hemsworth, Taika Waititi, Natalie Portman, Chris Pratt, Tessa Thompson",
    Year: "2022-07-07",
    Duration: "1min 2sec",
  },
  {
    Movie: "",
    Thumbnail: wolf,
    Scene: wolfscene,
    Logo: wolflogo,
    Name: "Wolf Of Wallstreet",
    Description: "A New York stockbroker refuses to cooperate in a large securities fraud case involving corruption on Wall Street, corporate banking world and mob infiltration. Based on Jordan Belfort's autobiography.",
    Genre: "Crime, Drama, Comedy",
    Actors: "Leonardo Di Caprio ,Cristin Milioti, Matthew McConaughey, Jon Bernthal, Zineb Oukach, J.T. O'Connor",
    Year: "2013-12-25",
    Duration: "180 min",
  },
  {
    Movie: "",
    Thumbnail: mrs,
    Scene: "",
    Logo: "",
    Name: "Mr and Mrs Smith",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "https://ipfs.io/ipfs/QmPGg4rCAaJzdYNk4FB5f9jgLu7itCLeqCHkXt3ijGFF2H?filename=rushhour1.mp4",
    Thumbnail: rushhour1thumb,
    Scene: rushour1scenes,
    Logo: RushHour1Logo,
    Name: "Rush Hour",
    Description: "When a Chinese consul's young daughter is kidnapped, Hong Kong Detective Lee must team up with Carter, a loud-mouthed LA detective. Distinctive work styles and cultural differences pose hiccups.",
    Genre: "Action,Comedy,Crime,Thriller",
    Actors: "Jackie Chan, Chris Tucker, Ken Leung, Tom Wilkinson, Tzi Ma",
    Year: "September 18, 1998",
    Duration: "98 min",
  },
  {
    Movie: "",
    Thumbnail: hob,
    Scene: "",
    Logo: "",
    Name: "Hobbit",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: shrek,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: reven,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: imit,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: topgu,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: lucy,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: bayw,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: tomb,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: amaz,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: bigs,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: secona,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: ted,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
  {
    Movie: "",
    Thumbnail: amerp,
    Scene: "",
    Logo: "",
    Name: "",
    Description: "",
    Genre: "",
    Actors: "",
    Year: "",
    Duration: "",
  },
];
